// extracted by mini-css-extract-plugin
export var adressbar = "magaziny-module--adressbar--yZ+10";
export var col = "magaziny-module--col--PvICg";
export var floating = "magaziny-module--floating--rnEiy";
export var magaz = "magaziny-module--magaz--soFzF";
export var wrapper = "magaziny-module--wrapper--mUfAh";